import axios from 'axios';
import { Address } from '../../models';

export interface CESService {
  supplyPointId: string;
  type: string;
  quotableSupplyPoint: boolean;
}

export interface CESProperty {
  propertyId: string;
  propertyAddress: string;
  searchScore: string;
  services: CESService[];
}

export interface CESProperties {
  addressId: string;
  krakenPropertiesSearchTerm: string;
  originalSearchTerm: string;
  properties: CESProperty[];
}

export interface CesAddressSearch extends Address {
  originalSearchTerm: string;
}

export const getCesProperties = async (
  url: string,
  params: CesAddressSearch,
  headers?: Record<string, string>
): Promise<CESProperties | undefined> => {
  const response = await axios.get(url, {
    headers,
    params,
  });
  return response.status === 200 ? (response.data as CESProperties) : undefined;
};

export interface InternalCesSearchProperty {
  propertyAddress: string;
}

export interface InternalCesSearchResponse {
  internalSearchTerm: string;
  originalSearchTerm: string;
  properties: InternalCesSearchProperty[];
}

export const searchInternalCesAddresses = async (
  searchTerm: string,
  signal?: AbortSignal
): Promise<InternalCesSearchProperty[]> => {
  const response = await axios.get('/api/sapaddress/v1/ces/internal-addresses-search', {
    params: { searchTerm },
    signal,
  });
  return (response.data as InternalCesSearchResponse)?.properties ?? [];
};
